import { Component, OnInit } from '@angular/core';
import { Customers} from '../../../_models/customers';
import { User } from '../../../_models/user';
import * as fromCustomers from '../../../customers/state/customers.reducer';
import * as customersActions from '../../../customers/state/customers.actions';
import * as fromRoot from '../../../state/app.reducer';
import * as rootActions from '../../../state/app.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './customers-edit-shell.component.html'
})

export class CustomersEditShellComponent implements OnInit {

    // errorMessage$: Observable<string>;
    customers$: Observable<Customers>;
    userList$: Observable<User[]>;

  constructor(
    private storeRoot: Store<fromRoot.State>,
    private store: Store<fromCustomers.State>
  ) {

    // Se cargan los agentes comerciales.
    this.store.dispatch( new customersActions.LoadUsers());
  }

  ngOnInit() {

    this.customers$ = this.store.pipe(select(fromCustomers.getCurrentCustomers)) as Observable<Customers>;

    // Se obtienen los agentes comerciales.
    this.userList$ = this.store.pipe(select(fromCustomers.getUserList)) as Observable<User[]>;

  }

  // NOTA: Las funciones realmente deberían quedar con una simple instrucción "dispatch".
  saveCustomers(customersIn: Customers): void {

    console.log('---> saveCustomers customersIn:');
    console.log(customersIn);

    if (customersIn.id === null) {
      console.log('Se va a CREAR un nuevo cliente.');
      this.store.dispatch( new customersActions.CreateCustomers(customersIn));
    } else {
      console.log('Se va a MODIFICAR un cliente existente.');
      this.store.dispatch( new customersActions.UpdateCustomers(customersIn));
    }
  }

  editCustomers(e: Event) {
    console.log('-> -> Pulsado botón editCustomers. Evento: ');
    console.log(e);

  }

  // --------------------------------------------------------------
  // Función para mostrar la ventana genérica de información.
  showInfoModal(modalParams) {

    console.log('---->>>>.... Ejecutando prodData-edit-shell showInfoModal: '
    + modalParams.value + ' ;Info: ' + modalParams.info + ' ;Link: ' + modalParams.link + ' ;Skin: ' + modalParams.skin);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({
      value: modalParams.value,
      info: modalParams.info,
      link: modalParams.link,
      param: modalParams.param,
      skin: modalParams.skin
    }));

  } // End function showInfoModal


} // End class CustomersEditShellComponent
